export const DefaultAlertEntity = {
  assignedUser: null,
  createdBy: '',
  createdDate: '',
  id: '',
  jsonData: '',
  lastModifiedBy: '',
  lastModifiedDate: '',
  notes: null,
  shortDesc: '',
  status: null,
  triggeredAlertId: '',
};
